module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bd-statistic",
      rawName: "v-bd-statistic"
    }],
    attrs: {
      "id": "appBody"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5245bdf4!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 239
// module chunks = 22